import ConfigForm from './ConfigForm.jsx';

const SCHEMA = [
  { key: 'accepted_types', label: 'Accepted types', kind: 'text' },
  { key: 'max_size', label: 'Max size (bytes)', kind: 'integer' },
  { key: 'min_items', label: 'Min items', kind: 'integer' },
  { key: 'max_items', label: 'Max items', kind: 'integer' },
  { key: 'multiple', label: 'Allow multiple', kind: 'boolean' },
];

export default function UploadConfig({ field, onConfigChange }) {
  return <ConfigForm schema={SCHEMA} config={field.config} onConfigChange={onConfigChange} />;
}
